import {
  getCountries,
  getCountryCallingCode,
  parsePhoneNumberFromString
} from 'libphonenumber-js/max'

const getCountryAndCallingCode = getCountries().map((country) => ({
  countryCode: country,
  callingCode: getCountryCallingCode(country),
  callingCodeLabel: '+' + getCountryCallingCode(country)
}))
export const getSortedCountries = () => {
  if (getCountryAndCallingCode) {
    return getCountryAndCallingCode.sort(
      (a, b) => Number(a.callingCode) - Number(b.callingCode)
    )
  }
  return []
}

export const verifyPhoneNumber = (number, countryCode) => {
  if (number && countryCode) {
    try {
      const phone = parsePhoneNumberFromString(number, countryCode)

      if (phone) {
        return phone.isValid()
      }
      return false
    } catch (e) {
      console.log(e)
      return false
    }
  }
  return false
}

export const currencyConverter = (currencyRate, amountValue) => {
  let rate = currencyRate
  let amount = amountValue
  let valueInInr = 0

  if (typeof currencyRate === 'string') {
    rate = parseFloat(currencyRate)
  }
  if (typeof amountValue === 'string') {
    amount = parseFloat(amountValue)
  }
  const multipliedValue = rate * amount
  const floatValue = parseFloat(multipliedValue.toFixed(2))
  const commaFormattedValue = floatValue.toLocaleString('en-in')
  const decimalValue = commaFormattedValue.split('.')[1]

  valueInInr = commaFormattedValue

  if (!decimalValue) {
    valueInInr = `${valueInInr}.00`
  }

  if (decimalValue && decimalValue.length === 1) {
    valueInInr = `${valueInInr}0`
  }

  return valueInInr
}

export const commaSeparator = (amountValue) => {
  if (!amountValue) {
    return 0
  }

  let value = amountValue

  if (typeof amountValue === 'string') {
    value = parseFloat(amountValue)
  }

  const floatValue = parseFloat(value.toFixed(2))
  const commaFormattedValue = floatValue.toLocaleString('en-in')
  const decimalValue = commaFormattedValue.split('.')[1]
  value = commaFormattedValue

  if (!decimalValue) {
    value = `${value}.00`
  }

  if (decimalValue && decimalValue.length === 1) {
    value = `${value}0`
  }

  return value
}

export const capitalizeFirstLetter = (str) => {
  if (str && str.length > 1) {
    return str.charAt(0).toUpperCase() + str.slice(1)
  }
  return ''
}

export const getInitials = (str) => {
  const arr = str.split(' ')
  if (arr && arr.length > 1) {
    return (
      arr[0].slice(0, 1).toString().toUpperCase() +
      arr[1].slice(0, 1).toString().toUpperCase()
    )
  } else if (arr && arr.length === 1) {
    return arr[0].slice(0, 1).toString().toUpperCase()
  }
  return ''
}
